import { useTranslation } from "react-i18next";

import { useHeaderContext } from "@/contexts/HeaderContext";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { MEDIA_QUERY } from "@/utils/mediaQueries";

import PropHeroLogo from "./PropHeroLogo";
import PropHeroSelectCountry from "./PropHeroSelectCountry";

const PropHeroHeader = () => {
  const { i18n } = useTranslation();
  const isMobile = useMediaQuery(MEDIA_QUERY.mobile);
  const { hasScreenHeaderWithBack } = useHeaderContext();

  // Add language change handler
  const handleLanguageChange = (event: { language: "en" | "es" }) => {
    void i18n.changeLanguage(event.language);
  };

  // Hide header on mobile when screen has ScreenHeaderWithBack
  if (isMobile && hasScreenHeaderWithBack) {
    return null;
  }

  return (
    <div className="relative lg:fixed top-0 pt-6 lg:pt-12 px-12 z-10 flex items-center w-full justify-center lg:justify-between">
      <PropHeroLogo />
      {!isMobile && (
        <PropHeroSelectCountry
          currentLanguage={i18n.language as "en" | "es"}
          onChange={handleLanguageChange}
        />
      )}
    </div>
  );
};

export default PropHeroHeader;
